/* ==========================================================================
   INCINOV JEWELLERY — Genel betikler

   Kütüphane yok, derleme adımı yok. Inline onclick yok — hepsi
   event listener. Hedef ES2019+ modern tarayıcı.

   Betik hiç yüklenmese de sayfa çalışır: giriş animasyonu CSS'te
   gizlemeyi yapar ama .giris sınıfı yoksa içerik zaten görünür,
   menü/arama panelleri details/summary değil ama <a> bağlantıları
   gerçek sayfalara gider.
   ========================================================================== */

(function () {
  'use strict';

  /* Kullanıcı hareket azaltma tercihi belirtmiş mi */
  var hareketAzalt = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Odaklanabilir öğe seçicisi — odak tuzağı ve panel açılışında kullanılır */
  var ODAKLANABILIR =
    'a[href], button:not([disabled]), input:not([disabled]), ' +
    'select:not([disabled]), textarea:not([disabled]), ' +
    'summary, [tabindex]:not([tabindex="-1"])';

  /* ------------------------------------------------------------------
     Giriş hareketi

     .giris sınıflı öğeler görüş alanına girince .gorunur alır.
     data-gecikme="3" varsa 3 × 60ms transition-delay uygulanır —
     ızgaradaki kartlar sırayla belirir.

     🪤 Hareket azaltma açıksa gözlemci hiç kurulmaz. Kurulup da
     hemen tetiklenmesi değil, hiç kurulmaması gerekir: IntersectionObserver
     yalnızca görüş alanındakileri işaretler, sayfa altındaki kartlar
     gizli kalırdı.
     ------------------------------------------------------------------ */
  function girisHareketiKur() {
    var ogeler = document.querySelectorAll('.giris:not(.gorunur)');
    if (!ogeler.length) return;

    /* Gecikme her durumda yazılır — hareket azaltmada CSS zaten
       geçişi kapattığı için zararsız */
    ogeler.forEach(function (oge) {
      var sira = parseInt(oge.getAttribute('data-gecikme'), 10);
      if (!isNaN(sira) && sira > 0) {
        /* Üst sınır: 10'dan sonrası beklemeye dönüşür, sıra hissi kaybolur */
        var gecikme = Math.min(sira, 10) * 60;
        oge.style.transitionDelay = gecikme + 'ms';
      }
    });

    /* Hareket azaltma açık veya tarayıcı desteklemiyorsa: hepsi
       doğrudan görünür. Animasyon yok ama içerik asla kaybolmaz. */
    if (hareketAzalt.matches || !('IntersectionObserver' in window)) {
      ogeler.forEach(function (oge) {
        oge.classList.add('gorunur');
      });
      return;
    }

    var gozlemci = new IntersectionObserver(
      function (girdiler) {
        girdiler.forEach(function (girdi) {
          if (!girdi.isIntersecting) return;
          girdi.target.classList.add('gorunur');
          gozlemci.unobserve(girdi.target);
        });
      },
      {
        /* Öğe alttan %12 içeri girince tetiklenir — kullanıcı
           oraya kaydırdığında animasyon bitmiş olur */
        rootMargin: '0px 0px -12% 0px',
        threshold: 0
      }
    );

    ogeler.forEach(function (oge) {
      gozlemci.observe(oge);
    });
  }

  /* ------------------------------------------------------------------
     Odak tuzağı

     Panel açıkken Tab dışarı çıkmasın. Geri kaldırma işlevi döner —
     panel kapanınca dinleyici de kalkar.
     ------------------------------------------------------------------ */
  function odakTuzagiKur(kapsayici) {
    function tusaBasildi(olay) {
      if (olay.key !== 'Tab') return;

      var ogeler = Array.prototype.filter.call(
        kapsayici.querySelectorAll(ODAKLANABILIR),
        function (oge) {
          /* Gizlenmiş öğeler sekme sırasında yok sayılır */
          return oge.offsetParent !== null || oge === document.activeElement;
        }
      );
      if (!ogeler.length) return;

      var ilk = ogeler[0];
      var son = ogeler[ogeler.length - 1];

      if (olay.shiftKey && document.activeElement === ilk) {
        olay.preventDefault();
        son.focus();
      } else if (!olay.shiftKey && document.activeElement === son) {
        olay.preventDefault();
        ilk.focus();
      }
    }

    kapsayici.addEventListener('keydown', tusaBasildi);
    return function kaldir() {
      kapsayici.removeEventListener('keydown', tusaBasildi);
    };
  }

  /* ------------------------------------------------------------------
     Gövde kaydırma kilidi

     Birden çok panel (menü + sepet çekmecesi) aynı anda kilit
     isteyebilir. Sayaçla tutulur ki ilki kapanınca kilit erken
     açılmasın.
     ------------------------------------------------------------------ */
  var kilitSayaci = 0;

  function kaydirmaKilitle() {
    kilitSayaci += 1;
    if (kilitSayaci === 1) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }
  }

  function kaydirmaCoz() {
    kilitSayaci = Math.max(0, kilitSayaci - 1);
    if (kilitSayaci === 0) {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
  }

  /* ------------------------------------------------------------------
     Panel yönetimi — ortak çekirdek

     Mobil menü ve arama paneli aynı davranışı paylaşır: aç/kapa,
     Escape, odak tuzağı, kaydırma kilidi, tetikleyiciye geri dönüş.
     Sepet çekmecesi de bunu kullanır (sepet.js dışarıdan çağırır).
     ------------------------------------------------------------------ */
  function PanelYap(ayar) {
    var panel = ayar.panel;
    var tetikleyiciler = ayar.tetikleyiciler || [];
    var acik = false;
    var tuzakKaldir = null;
    /* Sayfa yüklenirken `hidden` ile gelen panel (arama) görünürlüğünü
       bu özellikle yönetir: açılışta kaldırılır, kapanışta geri konur.
       Mobil menü `hidden` taşımaz — CSS `visibility` geçişiyle gizlenir. */
    var hiddenIleGizli = panel ? panel.hasAttribute('hidden') : false;
    var oncekiOdak = null;

    function ac() {
      if (acik || !panel) return;
      acik = true;
      oncekiOdak = document.activeElement;

      panel.setAttribute('data-acik', 'true');
      /* 🪤 `hidden` kaldırılmazsa panel `display:none` kalır ve "açık"
         olduğu hâlde görünmez (5 Eki 2026: mobil menü ve arama hiç
         açılmıyordu). */
      panel.removeAttribute('hidden');
      panel.removeAttribute('aria-hidden');
      panel.removeAttribute('inert');

      tetikleyiciler.forEach(function (dugme) {
        dugme.setAttribute('aria-expanded', 'true');
      });

      kaydirmaKilitle();
      tuzakKaldir = odakTuzagiKur(panel);

      /* Odak panele taşınır. Önce özel bir hedef (arama alanı gibi),
         yoksa ilk odaklanabilir öğe, o da yoksa panelin kendisi. */
      var hedef =
        (ayar.odakSecici && panel.querySelector(ayar.odakSecici)) ||
        panel.querySelector(ODAKLANABILIR) ||
        panel;

      /* Bir kare beklenir: panel CSS geçişiyle açılıyorsa henüz
         görünmez durumda olabilir, görünmeyen öğe odak almaz */
      window.requestAnimationFrame(function () {
        try {
          hedef.focus({ preventScroll: true });
        } catch (hata) {
          /* Eski tarayıcı preventScroll bilmiyorsa sade çağrı */
          try {
            hedef.focus();
          } catch (ikinciHata) {
            /* Odak verilemezse panel yine de açık — sessizce geç */
          }
        }
      });

      if (typeof ayar.acildi === 'function') ayar.acildi(panel);
    }

    function kapat() {
      if (!acik || !panel) return;
      acik = false;

      panel.removeAttribute('data-acik');
      panel.setAttribute('aria-hidden', 'true');
      /* Geri konmazsa `hidden` ile yönetilen panel (arama) kapanmaz. */
      if (hiddenIleGizli) panel.setAttribute('hidden', '');

      tetikleyiciler.forEach(function (dugme) {
        dugme.setAttribute('aria-expanded', 'false');
      });

      if (tuzakKaldir) {
        tuzakKaldir();
        tuzakKaldir = null;
      }
      kaydirmaCoz();

      /* Odak, paneli açan düğmeye döner — klavye kullanıcısı
         kaldığı yerden devam eder */
      if (oncekiOdak && typeof oncekiOdak.focus === 'function') {
        try {
          oncekiOdak.focus({ preventScroll: true });
        } catch (hata) {
          try {
            oncekiOdak.focus();
          } catch (ikinciHata) {
            /* yut */
          }
        }
      }
      oncekiOdak = null;

      if (typeof ayar.kapandi === 'function') ayar.kapandi(panel);
    }

    function degistir() {
      if (acik) {
        kapat();
      } else {
        ac();
      }
    }

    return {
      ac: ac,
      kapat: kapat,
      degistir: degistir,
      acikMi: function () {
        return acik;
      },
      panel: panel
    };
  }

  /* Açık panellerin kaydı — Escape hepsini kapatabilsin */
  var paneller = [];

  function acikPaneliKapat() {
    /* Sondan başa: en son açılan önce kapanır */
    for (var i = paneller.length - 1; i >= 0; i--) {
      if (paneller[i].acikMi()) {
        paneller[i].kapat();
        return true;
      }
    }
    return false;
  }

  /* ------------------------------------------------------------------
     Mobil menü
     ------------------------------------------------------------------ */
  var mobilMenu = null;

  function mobilMenuKur() {
    var panel = document.querySelector('[data-menu]');
    if (!panel) return;

    var dugmeler = Array.prototype.slice.call(
      document.querySelectorAll('[data-menu-ac]')
    );
    if (!dugmeler.length) return;

    /* Başlangıçta kapalı olduğu kesinleşsin — sunucudan hatalı
       gelirse burada düzelir */
    panel.setAttribute('aria-hidden', 'true');
    dugmeler.forEach(function (dugme) {
      dugme.setAttribute('aria-expanded', 'false');
      if (panel.id) dugme.setAttribute('aria-controls', panel.id);
    });

    mobilMenu = PanelYap({
      panel: panel,
      tetikleyiciler: dugmeler
    });
    paneller.push(mobilMenu);

    dugmeler.forEach(function (dugme) {
      dugme.addEventListener('click', function (olay) {
        olay.preventDefault();
        mobilMenu.degistir();
      });
    });

    /* Panel içindeki kapatma düğmesi ve arka plan örtüsü */
    panel.addEventListener('click', function (olay) {
      if (olay.target.closest('[data-menu-kapat]')) {
        olay.preventDefault();
        mobilMenu.kapat();
      }
    });

    altMenuleriKur(panel);

    /* Menüden bir bağlantıya tıklanınca panel kapanır — aynı
       sayfadaki çapa bağlantılarında panel açık kalmasın */
    panel.addEventListener('click', function (olay) {
      var baglanti = olay.target.closest('a[href]');
      if (baglanti) mobilMenu.kapat();
    });
  }

  /* Mobil menüde ok düğmesi alt listeyi açar/kapatır; başlık yazısı
     bir bağlantıdır ve kendi sayfasına gider. */
  function altMenuleriKur(panel) {
    panel.addEventListener('click', function (olay) {
      var dugme = olay.target.closest('[data-alt-ac]');
      if (!dugme) return;
      olay.preventDefault();

      var liste = document.getElementById(dugme.getAttribute('aria-controls'));
      if (!liste) return;

      var acilacak = dugme.getAttribute('aria-expanded') !== 'true';
      dugme.setAttribute('aria-expanded', acilacak ? 'true' : 'false');
      liste.hidden = !acilacak;
    });
  }

  /* ------------------------------------------------------------------
     Arama paneli
     ------------------------------------------------------------------ */
  var aramaPaneli = null;

  function aramaPaneliKur() {
    var panel = document.querySelector('[data-arama-panel]');
    if (!panel) return;

    var dugmeler = Array.prototype.slice.call(
      document.querySelectorAll('[data-arama-ac]')
    );
    if (!dugmeler.length) return;

    panel.setAttribute('aria-hidden', 'true');
    dugmeler.forEach(function (dugme) {
      dugme.setAttribute('aria-expanded', 'false');
      if (panel.id) dugme.setAttribute('aria-controls', panel.id);
    });

    aramaPaneli = PanelYap({
      panel: panel,
      tetikleyiciler: dugmeler,
      /* Açılınca doğrudan yazmaya başlanabilsin */
      odakSecici: '[data-arama-alan]'
    });
    paneller.push(aramaPaneli);

    dugmeler.forEach(function (dugme) {
      dugme.addEventListener('click', function (olay) {
        olay.preventDefault();
        aramaPaneli.degistir();
      });
    });

    panel.addEventListener('click', function (olay) {
      if (olay.target.closest('[data-arama-kapat]')) {
        olay.preventDefault();
        aramaPaneli.kapat();
      }
    });
  }

  /* ------------------------------------------------------------------
     Açılır kapanır bloklar

     Kural: <details>/<summary> kullanılabiliyorsa JS'e gerek yok —
     tarayıcı zaten açıp kapatıyor, ekran okuyucu da biliyor.
     Buradaki iş yalnızca yüksekliği ölçüp yumuşak geçiş vermek.

     [data-katla]      → <details> öğesi
     [data-katla-govde] → içindeki sarmalayıcı, yüksekliği animasyonlanır
     ------------------------------------------------------------------ */
  function katlananlariKur() {
    var bloklar = document.querySelectorAll('[data-katla]');

    bloklar.forEach(function (blok) {
      if (blok.hasAttribute('data-katla-hazir')) return;

      var govde = blok.querySelector('[data-katla-govde]');
      if (!govde) return;

      blok.setAttribute('data-katla-hazir', '');

      /* Açık başlıyorsa yüksekliği hemen doğru olsun */
      govde.style.height = blok.open ? 'auto' : '0px';

      blok.addEventListener('toggle', function () {
        if (hareketAzalt.matches) {
          govde.style.height = blok.open ? 'auto' : '0px';
          return;
        }

        if (blok.open) {
          govde.style.height = govde.scrollHeight + 'px';
          /* Geçiş bitince auto'ya dön — içerik sonradan değişirse
             (görsel yüklenmesi gibi) kutu kırpmasın */
          govde.addEventListener(
            'transitionend',
            function () {
              if (blok.open) govde.style.height = 'auto';
            },
            { once: true }
          );
        } else {
          /* Kapanış için önce ölçülebilir bir yükseklik gerekir:
             auto'dan 0'a geçiş animasyonlanmaz */
          govde.style.height = govde.scrollHeight + 'px';
          window.requestAnimationFrame(function () {
            govde.style.height = '0px';
          });
        }
      });
    });
  }

  /* ------------------------------------------------------------------
     Ürün galerisi

     [data-galeri] içinde küçük görsel düğmelerine basılınca ana
     görsel değişir. Küçükler <button> olduğu için klavye zaten
     çalışır — ayrıca keydown dinlenmez.

     🪤 Incinov'da her ürünün dört görseli var (beyaz zemin, siyah
     zemin, stand, premium konsept). srcset temizlenmezse tarayıcı
     eski setten seçim yapmaya devam eder ve görsel değişmez.
     ------------------------------------------------------------------ */
  function urunGalerisiKur() {
    var galeriler = document.querySelectorAll('[data-galeri]');

    galeriler.forEach(function (galeri) {
      var buyuk = galeri.querySelector('[data-galeri-buyuk]');
      var kucukler = Array.prototype.slice.call(
        galeri.querySelectorAll('[data-galeri-kucuk]')
      );
      if (!buyuk || kucukler.length < 2) return;

      function kucugeGec(kucuk) {
        var kaynak = kucuk.getAttribute('data-galeri-kaynak');
        if (!kaynak) return;

        var kaynakSet = kucuk.getAttribute('data-galeri-kaynak-set') || '';
        var alt = kucuk.getAttribute('data-galeri-alt') || '';

        kucukler.forEach(function (digeri) {
          if (digeri === kucuk) {
            digeri.setAttribute('aria-current', 'true');
          } else {
            digeri.removeAttribute('aria-current');
          }
        });

        function gorseliYaz() {
          /* Sıra önemli: önce srcset temizlenir, sonra src yazılır */
          buyuk.srcset = kaynakSet;
          buyuk.src = kaynak;
          buyuk.alt = alt;
        }

        if (hareketAzalt.matches) {
          gorseliYaz();
          return;
        }

        /* Kısa bir soluklaşma — görsel yerine oturana kadar
           kutunun boş kalması yerine eskisi soluklaşır */
        buyuk.setAttribute('data-degisiyor', '');
        window.setTimeout(function () {
          gorseliYaz();
          buyuk.removeAttribute('data-degisiyor');
        }, 180);
      }

      kucukler.forEach(function (kucuk) {
        kucuk.addEventListener('click', function (olay) {
          olay.preventDefault();
          kucugeGec(kucuk);
        });
      });

      /* Küçükler arasında ok tuşlarıyla gezinme */
      galeri.addEventListener('keydown', function (olay) {
        var kucuk = olay.target.closest('[data-galeri-kucuk]');
        if (!kucuk) return;

        var yon = 0;
        if (olay.key === 'ArrowRight' || olay.key === 'ArrowDown') yon = 1;
        if (olay.key === 'ArrowLeft' || olay.key === 'ArrowUp') yon = -1;
        if (yon === 0) return;

        olay.preventDefault();
        var sira = kucukler.indexOf(kucuk) + yon;
        if (sira < 0) sira = kucukler.length - 1;
        if (sira >= kucukler.length) sira = 0;

        kucukler[sira].focus();
        kucugeGec(kucukler[sira]);
      });

      /* Betik çalıştı işareti — CSS küçükleri ancak o zaman
         etkileşimli gösterir */
      galeri.setAttribute('data-galeri-hazir', '');
    });
  }

  /* ------------------------------------------------------------------
     Escape — açık paneli kapat

     Tek dinleyici belgede. Sepet çekmecesi de paneller dizisine
     kaydolduğu için aynı tuş onu da kapatır.
     ------------------------------------------------------------------ */
  /* ------------------------------------------------------------------
     Başlık kaydırma durumu

     Sayfa biraz kayınca başlığa "ust-bilgi--kaydirildi" eklenir,
     CSS logoyu küçültür ve üst satırı daraltır. Dinleyici belgeye
     bağlı; başlık her seferinde yeniden aranır, düzenleyicide
     section yeniden yüklense de çalışmaya devam eder.

     🪤 Eşik iki yönlü (gecikmeli): 80px'te küçülür, 20px'in altında
     büyür. Tek eşik olsaydı başlık küçülünce sayfa yüksekliği
     değişir, kaydırma eşiğin iki yanında gidip gelir, titrer.
     ------------------------------------------------------------------ */
  function kaydirmaIzleKur() {
    var bekliyor = false;

    function guncelle() {
      bekliyor = false;
      var baslik = document.querySelector('[data-ust-bilgi]');
      if (!baslik) return;
      var y = window.scrollY || window.pageYOffset;
      var kucuk = baslik.classList.contains('ust-bilgi--kaydirildi');
      var degisti = false;
      if (!kucuk && y > 80) { baslik.classList.add('ust-bilgi--kaydirildi'); degisti = true; }
      else if (kucuk && y < 20) { baslik.classList.remove('ust-bilgi--kaydirildi'); degisti = true; }
      /* Küçülme 0.3 sn'lik geçişle oluyor — geçiş bitince ölç */
      if (degisti) window.setTimeout(function () { yukseklikYaz(baslik); }, 350);
      else yukseklikYaz(baslik);
    }

    /* --baslik-yukseklik: yapışkan başlığın o anki yüksekliği.
       Koleksiyon araç çubuğu, filtre sütunu, politika gezinmesi
       gibi yapışkan öğeler bunun altında durur. Başlık yapışkan
       değilse 0 — öğeler en üste yapışır. Başlık küçülünce değişir. */
    function yukseklikYaz(baslik) {
      var yapiskan = baslik.classList.contains('ust-bilgi--yapiskan');
      var h = yapiskan ? Math.round(baslik.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--baslik-yukseklik', h + 'px');
    }

    window.addEventListener(
      'scroll',
      function () {
        if (bekliyor) return;
        bekliyor = true;
        window.requestAnimationFrame(guncelle);
      },
      { passive: true }
    );
    window.addEventListener('resize', function () {
      var baslik = document.querySelector('[data-ust-bilgi]');
      if (baslik) yukseklikYaz(baslik);
    });
    guncelle();
  }

  /* ------------------------------------------------------------------
     Mega panel kapatma

     Panel hover ve :focus-within ile açılır (CSS). Kapat düğmesi ya
     da Escape, başlığa "ust-menu__oge--kapali" ekler; fare başlıktan
     çıkınca ya da odak dışarı gidince kalkar, bir sonraki hover'da
     panel yeniden açılır. Dinleyiciler belgeye bağlı — düzenleyicide
     section yeniden yüklense de çalışır.
     ------------------------------------------------------------------ */
  function megaPanelKur() {
    var KAPALI = 'ust-menu__oge--kapali';

    function kapat(oge) {
      if (!oge) return;
      oge.classList.add(KAPALI);
      var ana = oge.querySelector('.ust-menu__baglanti');
      /* Odak panelin içinde kalırsa :focus-within paneli açık tutar */
      if (ana && oge.contains(document.activeElement)) ana.focus();
    }

    document.addEventListener('click', function (olay) {
      var dugme = olay.target.closest('[data-mega-kapat]');
      if (dugme) kapat(dugme.closest('[data-mega-oge]'));
    });

    document.addEventListener('keydown', function (olay) {
      if (olay.key !== 'Escape') return;
      var oge = document.activeElement && document.activeElement.closest('[data-mega-oge]');
      if (oge) kapat(oge);
    });

    document.addEventListener('mouseout', function (olay) {
      var oge = olay.target.closest('[data-mega-oge].' + KAPALI);
      if (oge && !oge.contains(olay.relatedTarget)) oge.classList.remove(KAPALI);
    });

    document.addEventListener('focusout', function (olay) {
      var oge = olay.target.closest('[data-mega-oge].' + KAPALI);
      if (oge && !oge.contains(olay.relatedTarget)) oge.classList.remove(KAPALI);
    });
  }

  /* ------------------------------------------------------------------
     Hero vitrini

     Şerit yerel kaydırma + scroll-snap ile çalışır (dokunmatikte
     parmakla kayar, JS olmasa da gezilir). Burada yalnız: oklar,
     "01 / 06" sayacı, ilerleme çizgisi, görünür olmayan kartın
     klavyeden çıkarılması ve isteğe bağlı otomatik geçiş.

     🪤 Otomatik geçiş varsayılan kapalı (section ayarı). Açıksa
     üzerine gelince, odakta, sekme gizliyken ve hareket azaltma
     tercihinde durur.
     ------------------------------------------------------------------ */
  function heroVitrinKur() {
    document.querySelectorAll('[data-vitrin]').forEach(function (vitrin) {
      if (vitrin.dataset.kuruldu) return;
      vitrin.dataset.kuruldu = '1';

      var serit = vitrin.querySelector('[data-vitrin-serit]');
      var ogeler = serit ? Array.prototype.slice.call(serit.children) : [];
      if (ogeler.length === 0) return;

      var siraYazi = vitrin.querySelector('[data-vitrin-sira]');
      var ilerleme = vitrin.querySelector('[data-vitrin-ilerleme]');
      var onceki = vitrin.querySelector('[data-vitrin-onceki]');
      var sonraki = vitrin.querySelector('[data-vitrin-sonraki]');
      var etkin = -1;

      function adim() {
        return ogeler.length > 1 ? ogeler[1].offsetLeft - ogeler[0].offsetLeft : serit.clientWidth;
      }

      function siraBul() {
        var i = Math.round(serit.scrollLeft / Math.max(adim(), 1));
        return Math.min(Math.max(i, 0), ogeler.length - 1);
      }

      function guncelle() {
        var i = siraBul();
        /* Son karta kadar kaydırılamayan geniş ekranda (mobil peek) sonda say */
        if (serit.scrollLeft + serit.clientWidth >= serit.scrollWidth - 2) i = ogeler.length - 1;
        if (i === etkin) return;
        etkin = i;
        if (siraYazi) siraYazi.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
        if (ilerleme) ilerleme.style.width = ((i + 1) / ogeler.length) * 100 + '%';
        if (onceki) onceki.disabled = i === 0;
        if (sonraki) sonraki.disabled = i === ogeler.length - 1;
        ogeler.forEach(function (oge, j) {
          var kart = oge.querySelector('a');
          if (kart) kart.tabIndex = j === i ? 0 : -1;
        });
      }

      function git(i) {
        var hedef = (i + ogeler.length) % ogeler.length;
        serit.scrollTo({ left: ogeler[hedef].offsetLeft - ogeler[0].offsetLeft });
      }

      var bekliyor = false;
      serit.addEventListener(
        'scroll',
        function () {
          if (bekliyor) return;
          bekliyor = true;
          window.requestAnimationFrame(function () {
            bekliyor = false;
            guncelle();
          });
        },
        { passive: true }
      );

      if (onceki) onceki.addEventListener('click', function () { git(siraBul() - 1); });
      if (sonraki) sonraki.addEventListener('click', function () { git(siraBul() + 1); });

      serit.addEventListener('keydown', function (olay) {
        if (olay.key === 'ArrowRight') { olay.preventDefault(); git(siraBul() + 1); }
        if (olay.key === 'ArrowLeft') { olay.preventDefault(); git(siraBul() - 1); }
      });

      guncelle();

      var sure = parseInt(vitrin.dataset.otomatik, 10);
      if (!sure || hareketAzalt.matches) return;

      var duraklat = false;
      ['mouseenter', 'focusin'].forEach(function (ad) {
        vitrin.addEventListener(ad, function () { duraklat = true; });
      });
      ['mouseleave', 'focusout'].forEach(function (ad) {
        vitrin.addEventListener(ad, function (olay) {
          if (ad === 'focusout' && vitrin.contains(olay.relatedTarget)) return;
          duraklat = false;
        });
      });

      window.setInterval(function () {
        if (duraklat || document.hidden || !document.body.contains(vitrin)) return;
        git(siraBul() + 1);
      }, sure);
    });
  }

  /* ------------------------------------------------------------------
     Ürün kaydırıcı — ortadaki kart

     Şerit scroll-snap ile kendi kayar. Burada: öne çıkan kartı bulup
     "--merkez" vermek (masaüstü: en soldaki, mobil: ortadaki), oklar,
     ilerleme çizgisi, "01 / 08" sayacı.
     ------------------------------------------------------------------ */
  function kaydiriciKur() {
    document.querySelectorAll('[data-kaydirici]').forEach(function (kutu) {
      if (kutu.dataset.kuruldu) return;
      kutu.dataset.kuruldu = '1';

      var serit = kutu.querySelector('[data-kaydirici-serit]');
      var ogeler = serit ? Array.prototype.slice.call(serit.querySelectorAll('[data-kaydirici-oge]')) : [];
      if (ogeler.length === 0) return;

      var onceki = kutu.querySelector('[data-kaydirici-onceki]');
      var sonraki = kutu.querySelector('[data-kaydirici-sonraki]');
      var ilerleme = kutu.querySelector('[data-kaydirici-ilerleme]');
      var siraYazi = kutu.querySelector('[data-kaydirici-sira]');
      var etkin = -1;

      /* Hizalama CSS'ten okunur: masaüstünde kartlar başa (start),
         mobilde ortaya (center) oturur. Öne çıkan kart buna göre
         en soldaki ya da ortadaki. */
      function basaHizali() {
        var hiza = window.getComputedStyle(ogeler[0]).scrollSnapAlign || '';
        return hiza.indexOf('start') !== -1;
      }

      function solDolgu() {
        return parseFloat(window.getComputedStyle(serit).paddingLeft) || 0;
      }

      function hedefKonum(oge) {
        return basaHizali()
          ? oge.offsetLeft - solDolgu()
          : oge.offsetLeft + oge.offsetWidth / 2 - serit.clientWidth / 2;
      }

      function merkezBul() {
        var enIyi = 0;
        var enAz = Infinity;
        ogeler.forEach(function (oge, i) {
          var fark = Math.abs(hedefKonum(oge) - serit.scrollLeft);
          if (fark < enAz) { enAz = fark; enIyi = i; }
        });
        return enIyi;
      }

      function guncelle() {
        var i = merkezBul();
        if (i === etkin) return;
        etkin = i;
        ogeler.forEach(function (oge, j) {
          oge.classList.toggle('kaydirici-kart--merkez', j === i);
        });
        if (onceki) onceki.disabled = i === 0;
        if (sonraki) sonraki.disabled = i === ogeler.length - 1;
        if (ilerleme) ilerleme.style.width = ((i + 1) / ogeler.length) * 100 + '%';
        if (siraYazi) siraYazi.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
      }

      function git(i, anlik) {
        var hedef = Math.min(Math.max(i, 0), ogeler.length - 1);
        serit.scrollTo({
          left: hedefKonum(ogeler[hedef]),
          behavior: anlik ? 'auto' : 'smooth'
        });
      }

      var bekliyor = false;
      serit.addEventListener('scroll', function () {
        if (bekliyor) return;
        bekliyor = true;
        window.requestAnimationFrame(function () {
          bekliyor = false;
          guncelle();
        });
      }, { passive: true });

      if (onceki) onceki.addEventListener('click', function () { git(merkezBul() - 1); });
      if (sonraki) sonraki.addEventListener('click', function () { git(merkezBul() + 1); });
      serit.addEventListener('keydown', function (olay) {
        if (olay.key === 'ArrowRight') { olay.preventDefault(); git(merkezBul() + 1); }
        if (olay.key === 'ArrowLeft') { olay.preventDefault(); git(merkezBul() - 1); }
      });

      /* Mobilde (ortalı) ikinci karta konumlan — iki yanda komşu
         görünsün. Masaüstünde (başa hizalı) ilk kart zaten solda. */
      if (!basaHizali() && ogeler.length > 2) git(1, true);
      guncelle();

      /* Ekran genişliği değişince hizalama değişebilir */
      window.addEventListener('resize', function () {
        etkin = -1;
        guncelle();
      });
    });
  }

  function escapeKur() {
    document.addEventListener('keydown', function (olay) {
      if (olay.key !== 'Escape' && olay.key !== 'Esc') return;
      if (acikPaneliKapat()) olay.preventDefault();
    });
  }

  /* ------------------------------------------------------------------
     Başlangıç
     ------------------------------------------------------------------ */
  function kur() {
    try {
      mobilMenuKur();
      aramaPaneliKur();
      urunGalerisiKur();
      katlananlariKur();
      girisHareketiKur();
      escapeKur();
      kaydirmaIzleKur();
      megaPanelKur();
      heroVitrinKur();
      kaydiriciKur();
    } catch (hata) {
      /* Bir parça patlarsa sayfanın geri kalanı ayakta kalsın.
         Konsola yazılır, kullanıcıya bir şey gösterilmez. */
      if (window.console && console.warn) {
        console.warn('Incinov: genel betik kurulamadı', hata);
      }
    }
  }

  /* Tema düzenleyicisinde bölüm yeniden yüklenince tazelenecekler.
     Escape ve panel kayıtları yeniden kurulmaz — belgeye bağlı,
     iki kere dinlenirse panel açılıp hemen kapanır. */
  function tazele() {
    try {
      heroVitrinKur();
      kaydiriciKur();
      urunGalerisiKur();
      katlananlariKur();
      girisHareketiKur();
    } catch (hata) {
      if (window.console && console.warn) {
        console.warn('Incinov: bölüm tazelenemedi', hata);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kur);
  } else {
    kur();
  }

  document.addEventListener('shopify:section:load', tazele);

  /* ------------------------------------------------------------------
     Dışa açılan yüzey

     sepet.js bunları kullanır: kendi çekmecesini aynı panel
     çekirdeğiyle kurar, aynı Escape ve kaydırma kilidi sırasına
     katılır. Ayrı bir kilit mantığı yazmak iki panel aynı anda
     açıkken kaydırmayı erken açardı.
     ------------------------------------------------------------------ */
  window.Incinov = {
    PanelYap: PanelYap,
    panelleriKaydet: function (panelNesnesi) {
      paneller.push(panelNesnesi);
    },
    odakTuzagiKur: odakTuzagiKur,
    kaydirmaKilitle: kaydirmaKilitle,
    kaydirmaCoz: kaydirmaCoz,
    girisHareketiKur: girisHareketiKur,
    hareketAzalt: hareketAzalt,
    ODAKLANABILIR: ODAKLANABILIR
  };
})();
